(function($) {

  $(document).ready(function () {
    let prevIsSmallWinodw = true;
    let isSmallWinodw = true;
    let isInitialized = false;

    function init() {
      if ($(window).width() > 767) {
        isSmallWinodw = false;
      } else {
        isSmallWinodw = true;
      }

      if(isInitialized && prevIsSmallWinodw == isSmallWinodw) {
        return 0;
      }

      if(!isInitialized) {
        isInitialized = true;
      }

      prevIsSmallWinodw = isSmallWinodw;

      const $outputSm = $('#js-emaki-list-small-window');
      const $outputL = $('#js-emaki-list-l');
      const $outputR = $('#js-emaki-list-r');
      const $moreFilm = $('#js-emaki-film');
      const $moreWrap = $('#js-emaki-more');

      $outputSm.html('');
      $outputL.html('');
      $outputR.html('');

      if(isSmallWinodw) {
        const $sourceItems = $('#js-emaki-list-source li').clone(true);
        $outputSm.append('<ul class="c-emaki-list">');
        $outputSm.find('.c-emaki-list').append($sourceItems);
        $outputSm.find('li:gt(5)').hide();
      } else {
        const $sourceOddItems = $('#js-emaki-list-source li:odd').clone(true);
        const $sourceEvenItems = $('#js-emaki-list-source li:even').clone(true);
        $outputL.append('<ul class="c-emaki-list">');
        $outputR.append('<ul class="c-emaki-list">');
        $outputL.find('.c-emaki-list').append($sourceEvenItems);
        $outputR.find('.c-emaki-list').append($sourceOddItems);

        $outputL.find('li:gt(2)').hide();
        $outputR.find('li:gt(2)').hide();
        $moreFilm.removeClass('disabled').show();
        $moreWrap.show();
      }
    }

    function moreEmaki() {
      const $moreFilm = $('#js-emaki-film');
      const $moreBtn = $('#js-emaki-btn');
      const $moreWrap = $('#js-emaki-more');

      $moreBtn.on('click', function(e) {
        $moreFilm.addClass('disabled');

        if(!isSmallWinodw) {
          const $outputLItems = $('#js-emaki-list-l li:gt(2)');
          const $outputRItems = $('#js-emaki-list-r li:gt(2)');

          setTimeout(function() {
            $outputLItems.each(function(i,v) {
              $(this).delay(i*200).fadeIn(250);
            });
            $outputRItems.each(function(i,v) {
              $(this).delay((i+1)*200).fadeIn(250);
            });
          }, 350);

        } else {
          const $outputSmItems = $('#js-emaki-list-small-window li:gt(5)');
          $outputSmItems.each(function(i,v) {
            $(this).delay((i+1)*200).fadeIn(250);
          });
        }

        $moreFilm.one('transitionend', function() {
          $moreWrap.hide();
        });
      });
    }

    function modal() {
      const $prev = $('#js-emaki-modal-prev');
      const $next = $('#js-emaki-modal-next');
      const modalCount = $('.js-modal-source').length;
      const emakiIdStr = '#js-emaki-modal-frame';
      let $modal = {};
      let $img = {};
      let current = 0;
      let isPrev = true;
      let isNext = true;

      function currentCheck() {
        let numc = Number(current);
        if(numc <= 1) {
          $prev.hide();
          isPrev = false;
        } else {
          $prev.show();
          isPrev = true;
        }
        if(numc >= modalCount) {
          $next.hide();
          isNext = false;
        } else {
          $next.show();
          isNext = true;
        }
      }

      function modalContentOutput(id) {
        const $modalContent = $('#'+id+' .c-emaki-modal__content');
        const $output = $('#js-emaki-modal-output');
        $output.html($modalContent.clone());
      }

      function modalContentAnimate() {
        const $body = $modal.find('.c-emaki-modal__body');
        const $content = $modal.find('.c-emaki-modal__content');
        const $fig = $modal.find('.c-emaki-modal__fig');
        const $imgWrap = $modal.find('.c-emaki-modal__img');
        $img = $modal.find('.c-emaki-modal__img img');
        $imgWrap.removeClass('is-click');
        $content.scrollTop(0);
        $imgWrap.scrollLeft(0);
        // $body.css({'top': $(window).scrollTop() + 60 + 'px'});
        //画像が読み込まれて横長でブロックからはみ出しているものはアニメーションで表示
        $img.removeClass('square');
        if($img.width() / $img.height() < 1.6) {
          $img.addClass('square');
        }
        if($img.width() > $imgWrap.width()) {
          $img.addClass('wide');
          setTimeout(function() {
            let diff = $img.width() - $imgWrap.width();
            $img.css('left', diff * -1 + 'px');
            $img.one('transitionend', function() {
              setTimeout(function() {
                $img.removeAttr('style');
                $img.one('transitionend', function() {
                  $img.css('transition', 'height .35s linear');
                  setTimeout(function() {
                    $img.removeClass('wide');
                    $img.one('transitionend', function() {
                      $img.removeAttr('style');
                      $imgWrap.addClass('is-click');
                    });
                  }, 700);
                });
              }, 700);
            });
          }, 600)
        }
        $fig.addClass('is-active');
      }

      //モーダル表示
      $('.c-emaki-content__body').on('click', '[data-id]', function() {
        let id = $(this).attr('data-id');
        $modal = $(emakiIdStr);
        current = id.replace('emaki-modal-', '');
        currentCheck(current);
        modalContentOutput(id);
        $modal.fadeIn(200);
        modalContentAnimate();
      });

      function changeModalContent() {
        currentCheck(current);
        let id = 'emaki-modal-' + current;
        $('#js-emaki-modal-output').slideUp(400,function() {
          modalContentOutput(id);
          $(this).slideDown(400,function() {
            modalContentAnimate();
          });
        });
      }

      //移動
      $prev.on('click', function() {
        current = Number(current) - 1;
        changeModalContent();
      });
      $next.on('click', function() {
        current = Number(current) + 1;
        changeModalContent();
      });

      $(document).keyup(function(e){
        if($(emakiIdStr).css('display') !== 'none') {
          if(e.keyCode == 37 && isPrev) {
            $prev.trigger('click');
          }
          if(e.keyCode == 39 && isNext) {
            $next.trigger('click');
          }
          if(e.keyCode == 27) {
            $('.js-emaki-modal-close').trigger('click');
          }
        }
      });

      //モーダル閉じる
      $(emakiIdStr).on('click', '.js-emaki-modal-close', function() {
        $modal.fadeOut(200);
      });

      //モーダルの中の画像をスクロール可能に
      $('.c-emaki-modal').on('click', '.is-click', function() {
        $(this).find('img').css('transition', 'height .35s linear');
        $(this).closest('.c-emaki-modal').find('.c-emaki-modal__img').addClass('c-emaki-modal__img--scroll');
      });

      //モーダルの中の画像のスクロール解除
      $('.c-emaki-modal').on('click', '.c-emaki-modal__img--scroll', function() {
        $(this).removeClass('c-emaki-modal__img--scroll');
        $(this).one('transitionend', function() {
          $img.removeAttr('style');
        });
      });
    }

    $(window).on('resize', init);
    init();
    moreEmaki();
    modal();

  });
})(jQuery);
